import {
	type PaymentMode,
	type PaymentSubject,
	type ReceiptConfig,
	TAX_SYSTEM_CODES,
	VAT_CODES,
} from "@velizhanin-dev/bot-scenario"

export const VAT_LABELS: Record<(typeof VAT_CODES)[number], string> = {
	1: "Без НДС",
	2: "НДС 0%",
	3: "НДС 10%",
	4: "НДС 20%",
	5: "НДС 10/110",
	6: "НДС 20/120",
	7: "НДС 5%",
	8: "НДС 7%",
	9: "НДС 5/105",
	10: "НДС 7/107",
}

export const SUBJECT_LABELS: Record<PaymentSubject, string> = {
	service: "Услуга",
	commodity: "Товар",
	job: "Работа",
	payment: "Платёж",
	another: "Другое",
}

export const MODE_LABELS: Record<PaymentMode, string> = {
	full_payment: "Полный расчёт",
	full_prepayment: "Полная предоплата",
}

export const TAX_LABELS: Record<(typeof TAX_SYSTEM_CODES)[number], string> = {
	1: "ОСН",
	2: "УСН «доходы»",
	3: "УСН «доходы минус расходы»",
	5: "ЕСХН",
	6: "Патент",
}

export const DEFAULT_RECEIPT: ReceiptConfig = {
	vatCode: 1,
	paymentSubject: "service",
	paymentMode: "full_payment",
	contact: "email",
}
